<section class="section">
  @if (title()) {
    <h3 class="section-title">{{ title() }}</h3>
  }
  <div class="section-container">
    <ng-content />
  </div>
</section>
